import {
    FETCH_AUTHENTICATED_USER,
    FETCH_AUTHENTICATED_USER_ERROR,
    FETCH_AUTHENTICATED_USER_SUCCESS,
    AuthenticatedUserActionTypes,
    USER_LOGIN, USER_LOGIN_ERROR, USER_LOGIN_SUCCESS,
    UserLoginActionTypes, UserLogoutActionTypes,
    USER_LOGOUT, USER_LOGOUT_ERROR, USER_LOGOUT_SUCCESS, USER_REFRESH_SUCCESS, USER_REFRESH_ERROR,
    UserRefreshActionTypes
} from "../../actions/common/AuthenticatedUserActions";
import { RequestState } from "../../models/common/RequestState";
import {AuthenticatedUser, initialGuestUser} from "../../models/users/AuthenticatedUser";

export interface AuthenticatedUserState {
    isLoggedIn: boolean
    current: AuthenticatedUser | null
    request: RequestState
    isRefreshPossible: boolean
}

const initialState: AuthenticatedUserState = {
    isLoggedIn: false,
    current: null,
    isRefreshPossible: true,
    request: {
        error: null,
        isFetching: false,
        lastRequestSuccess: 0
    }
};

type ActionTypes = AuthenticatedUserActionTypes
    | UserLoginActionTypes
    | UserLogoutActionTypes
    | UserRefreshActionTypes

export const AuthenticatedUserReducer = ( state = initialState, action: ActionTypes ): AuthenticatedUserState => {

    switch( action.type ) {
        case FETCH_AUTHENTICATED_USER:
            return {
                ...state,
                request: {
                    error: null,
                    isFetching: true,
                    lastRequestSuccess: 0
                }
            };
        case FETCH_AUTHENTICATED_USER_SUCCESS:

            return {
                ...state,
                isLoggedIn: ((action.authenticatedUser?.id?.rawValue ?? 0) > 0),
                isRefreshPossible: ((action.authenticatedUser?.id?.rawValue ?? 0) > 0),
                current: action.authenticatedUser,
                request: {
                    error: null,
                    isFetching: false,
                    lastRequestSuccess: Date.now()
                }
            };
        case FETCH_AUTHENTICATED_USER_ERROR:

            return {
                ...state,
                isLoggedIn: false,
                current: null,
                request: {
                    error: action.error,
                    isFetching: false,
                    lastRequestSuccess: 0
                }
            };
        case USER_LOGIN: 
            return {
                ...state,
                isLoggedIn: false,
                request: {
                    error: null,
                    isFetching: true,
                    lastRequestSuccess: 0
                }
            };
        case USER_LOGIN_SUCCESS:
                return {
                    ...state,
                    isLoggedIn: true,
                    current: action.authenticatedUser,
                    isRefreshPossible: true,
                    request: {
                        error: null,
                        isFetching: false,
                        lastRequestSuccess: Date.now()
                    }
                };
        case USER_LOGIN_ERROR: 
            return {
                ...state,
                isLoggedIn: false,
                current: null,
                isRefreshPossible: false,
                request: {
                    error: action.error,
                    isFetching: false,
                    lastRequestSuccess: 0
                }
            };
        case USER_LOGOUT: 
            return {
                ...state,
                current: null,
                isLoggedIn: false,
                request: {
                    error: null,
                    isFetching: true,
                    lastRequestSuccess: 0
                }
            };
        case USER_LOGOUT_SUCCESS:
                return {
                    ...state,
                    isLoggedIn: false,
                    current: action.authUser,
                    isRefreshPossible: false,
                    request: {
                        error: null,
                        isFetching: false,
                        lastRequestSuccess: Date.now()
                    }
                };
        case USER_LOGOUT_ERROR: 
            return {
                ...state,
                isLoggedIn: false,
                current: null,
                request: {
                    error: action.error,
                    isFetching: false,
                    lastRequestSuccess: 0
                }
            };
        case USER_REFRESH_SUCCESS:
            return {
                ...state,
                isRefreshPossible: false,
            };
        case USER_REFRESH_ERROR:
            return {
                ...state,
                isRefreshPossible: false,
            };
        default:
            return state;
    }
};